// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfS6r5 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  width: 100%;
}

.jDfk5Y {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-size: var(--label-size);
}

.z6Rue2 {
  display: flex;
  align-items: center;
  position: relative;
  background: var(--input-bg, var(--surface-neutral-pale));
  border: 1px solid var(--input-border-color, var(--stroke-neutral-silver));
  border-radius: var(--radius-s);
  box-sizing: border-box;
}

.z6Rue2:not(.TX6B3d):not(.dwf5y0):hover {
  background: var(--input-bg, var(--surface-neutral-pale));
}

.JPtPoC,
.ChxXgE {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  color: var(--text-neutral-stronger);
}

.JPtPoC {
  left: var(--spacing-1-5);
}

.ChxXgE {
  right: var(--spacing-1-5);
}

.AZhBcI {
  appearance: none;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-size: var(--input-size);
  padding-top: var(--input-padding-top);
  padding-bottom: var(--input-padding-bottom);
  padding-left: var(--input-padding-left);
  padding-right: var(--input-padding-right);
  box-sizing: border-box;
}

.AZhBcI::placeholder {
  color: var(--text-neutral-stronger);
}

.HKYrE9 {
  --input-padding-left: var(--spacing-5);
}

.gPBBVU {
  --input-padding-right: var(--spacing-5);
}

.sBdKyG {
  --input-padding-left: var(--spacing-1-5);
}

.vS5CAO {
  --input-padding-right: var(--spacing-1-5);
}

.qgtKXB {
  --label-size: var(--font-size-md);
  --input-size: var(--font-size-md);
  --message-size: var(--font-size-sm);
  --input-padding-top: var(--input-v-padding, var(--spacing-2));
  --input-padding-bottom: var(--input-v-padding, var(--spacing-2));
}

.qgtKXB .z6Rue2 {
  min-height: var(
    --input-fixed-height,
    max(calc(var(--input-padding-top, var(--spacing-2)) + var(--input-padding-bottom, var(--spacing-2)) + 1.5em), 40px)
  );
  height: var(--input-fixed-height, auto);
  max-height: var(--input-fixed-height, none);
}

.m162gG {
  --label-size: var(--font-size-sm);
  --input-size: var(--font-size-sm);
  --message-size: var(--font-size-sm);
  --input-padding-top: var(--input-v-padding, var(--spacing-1));
  --input-padding-bottom: var(--input-v-padding, var(--spacing-1));
}

.m162gG .z6Rue2 {
  min-height: var(
    --input-fixed-height,
    max(calc(var(--input-padding-top, var(--spacing-1)) + var(--input-padding-bottom, var(--spacing-1)) + 1.5em), 40px)
  );
  height: var(--input-fixed-height, auto);
  max-height: var(--input-fixed-height, none);
}

.TX6B3d {
  background: var(--input-disabled-bg, var(--surface-neutral-pale));
  border-color: var(--input-disabled-border-color, var(--surface-neutral-pale));
  cursor: not-allowed;
}

.TX6B3d .AZhBcI {
  color: var(--text-neutral-strong);
}

.TX6B3d.XcxreX .AZhBcI {
  color: var(--text-neutral-stronger);
}

.dwf5y0 {
  background: var(--surface-neutral-pale);
  border-color: var(--stroke-neutral-subtle);
}

.IC8D2_ {
  border-color: var(--status-success);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;EACxD,yEAAyE;EACzE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,6DAA6D;EAC7D,gEAAgE;AAClE;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,6DAA6D;EAC7D,gEAAgE;AAClE;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,iEAAiE;EACjE,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  width: 100%;\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-size: var(--label-size);\n}\n\n.inputContainer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: var(--input-bg, var(--surface-neutral-pale));\n  border: 1px solid var(--input-border-color, var(--stroke-neutral-silver));\n  border-radius: var(--radius-s);\n  box-sizing: border-box;\n}\n\n.inputContainer:not(.disabled):not(.readonly):hover {\n  background: var(--input-bg, var(--surface-neutral-pale));\n}\n\n.left,\n.right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-neutral-stronger);\n}\n\n.left {\n  left: var(--spacing-1-5);\n}\n\n.right {\n  right: var(--spacing-1-5);\n}\n\n.input {\n  appearance: none;\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-size: var(--input-size);\n  padding-top: var(--input-padding-top);\n  padding-bottom: var(--input-padding-bottom);\n  padding-left: var(--input-padding-left);\n  padding-right: var(--input-padding-right);\n  box-sizing: border-box;\n}\n\n.input::placeholder {\n  color: var(--text-neutral-stronger);\n}\n\n.hasLeftElement {\n  --input-padding-left: var(--spacing-5);\n}\n\n.hasRightElement {\n  --input-padding-right: var(--spacing-5);\n}\n\n.noLeftElement {\n  --input-padding-left: var(--spacing-1-5);\n}\n\n.noRightElement {\n  --input-padding-right: var(--spacing-1-5);\n}\n\n.large {\n  --label-size: var(--font-size-md);\n  --input-size: var(--font-size-md);\n  --message-size: var(--font-size-sm);\n  --input-padding-top: var(--input-v-padding, var(--spacing-2));\n  --input-padding-bottom: var(--input-v-padding, var(--spacing-2));\n}\n\n.large .inputContainer {\n  min-height: var(\n    --input-fixed-height,\n    max(calc(var(--input-padding-top, var(--spacing-2)) + var(--input-padding-bottom, var(--spacing-2)) + 1.5em), 40px)\n  );\n  height: var(--input-fixed-height, auto);\n  max-height: var(--input-fixed-height, none);\n}\n\n.small {\n  --label-size: var(--font-size-sm);\n  --input-size: var(--font-size-sm);\n  --message-size: var(--font-size-sm);\n  --input-padding-top: var(--input-v-padding, var(--spacing-1));\n  --input-padding-bottom: var(--input-v-padding, var(--spacing-1));\n}\n\n.small .inputContainer {\n  min-height: var(\n    --input-fixed-height,\n    max(calc(var(--input-padding-top, var(--spacing-1)) + var(--input-padding-bottom, var(--spacing-1)) + 1.5em), 40px)\n  );\n  height: var(--input-fixed-height, auto);\n  max-height: var(--input-fixed-height, none);\n}\n\n.disabled {\n  background: var(--input-disabled-bg, var(--surface-neutral-pale));\n  border-color: var(--input-disabled-border-color, var(--surface-neutral-pale));\n  cursor: not-allowed;\n}\n\n.disabled .input {\n  color: var(--text-neutral-strong);\n}\n\n.disabled.filled .input {\n  color: var(--text-neutral-stronger);\n}\n\n.readonly {\n  background: var(--surface-neutral-pale);\n  border-color: var(--stroke-neutral-subtle);\n}\n\n.success {\n  border-color: var(--status-success);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gfS6r5`,
	"label": `jDfk5Y`,
	"inputContainer": `z6Rue2`,
	"disabled": `TX6B3d`,
	"readonly": `dwf5y0`,
	"left": `JPtPoC`,
	"right": `ChxXgE`,
	"input": `AZhBcI`,
	"hasLeftElement": `HKYrE9`,
	"hasRightElement": `gPBBVU`,
	"noLeftElement": `sBdKyG`,
	"noRightElement": `vS5CAO`,
	"large": `qgtKXB`,
	"small": `m162gG`,
	"filled": `XcxreX`,
	"success": `IC8D2_`
};
module.exports = ___CSS_LOADER_EXPORT___;
